$(() => {
  const $cancellationSummaryDetails = $(".cancellation-summary-details--title")

  $(".cancellation-summary-details--container").on({
    "details:open": () => {
      $cancellationSummaryDetails.text($cancellationSummaryDetails.data("hide"))
    },
    "details:close": () => {
      $cancellationSummaryDetails.text($cancellationSummaryDetails.data("show"))
    },
  })
})
